import {
  auditPaymentOrder,
  checkGovernmentProject,
  getGovernmentProjectDetail,
  getGovernmentProjectList,
  getPaymentOrderDetail,
  getPaymentOrderList,
  initPaymentOrder,
  nullifyGovernmentProject,
  removePaymentOrder,
  savePaymentOrder,
  submitPaymentOrder,
} from '../services';

// 过滤出城基中心和e平台数据
const formatDeclarationFormCheckDataList = (data = {}) => {
  const { declarationFormCheckDataList = [] } = data || {};
  const declarationFormCheckData =
    declarationFormCheckDataList?.filter(item => item.bizType === 2)?.[0] || {}; // 城基中心
  const eDeclarationFormCheckData =
    declarationFormCheckDataList?.filter(item => item.bizType === 1)?.[0] || {}; // e平台
  return {
    ...data,
    eDeclarationFormCheckData,
    declarationFormCheckData,
  };
};

export default {
  namespace: 'governmentProject',
  state: {
    paymentOrderDetail: {},
    governmentProjectCheckResult: {},
  },
  effects: {
    /**
     * 获取申报单列表
     */
    *getGovernmentProjectList({ payload }, { call }) {
      return yield call(getGovernmentProjectList, payload);
    },
    /**
     * 申报单详情
     */
    *getGovernmentProjectDetail({ payload }, { call, put }) {
      const result = yield call(getGovernmentProjectDetail, payload);
      const declarationFormCheckInfo = formatDeclarationFormCheckDataList(
        result?.declarationFormCheckInfo,
      );
      const newResult = {
        ...(result || {}),
        declarationFormCheckInfo,
      };
      return newResult || {};
    },
    /**
     * 作废申报单
     */
    *nullifyGovernmentProject({ payload }, { call }) {
      return yield call(nullifyGovernmentProject, payload);
    },
    /**
     * 一致性校验
     */
    *checkGovernmentProject({ payload }, { call, put }) {
      const result = yield call(checkGovernmentProject, payload);
      const declarationFormCheckResult = formatDeclarationFormCheckDataList(
        result?.declarationFormCheckResult,
      );
      const newResult = {
        ...(result || {}),
        declarationFormCheckResult,
      };
      yield put({
        type: 'update',
        payload: {
          governmentProjectCheckResult: newResult || {},
        },
      });
      return newResult || {};
    },
    /**
     * 获取支付单列表
     */
    *getPaymentOrderList({ payload }, { call }) {
      return yield call(getPaymentOrderList, payload);
    },
    /**
     * 发起支付单
     */
    *initPaymentOrder({ payload }, { call, put }) {
      return yield call(initPaymentOrder, payload);
    },
    /**
     * 保存
     */
    *savePaymentOrder({ payload }, { call }) {
      return yield call(savePaymentOrder, payload);
    },
    /**
     * 提交
     */
    *submitPaymentOrder({ payload }, { call }) {
      return yield call(submitPaymentOrder, payload);
    },
    /**
     * 审核
     */
    *auditPaymentOrder({ payload }, { call }) {
      return yield call(auditPaymentOrder, payload);
    },
    /**
     * 支付单详情
     */
    *getPaymentOrderInfo({ payload }, { call }) {
      return yield call(getPaymentOrderDetail, payload);
    },
    /**
     * 删除支付单
     */
    *removePaymentOrder({ payload }, { call }) {
      return yield call(removePaymentOrder, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
